
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-side-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-side-dialog.component.html',
  styleUrls: ['./modal-side-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalSideDialogComponent {
  @Input() active: boolean=false;

}
